export default {
  mounted(el, binding, vnode) {
    const { value } = binding;
    // 自定义指令的执行函数，，取到登录缓存的按钮权限数组，赋值给全局对象userMsg
    global.ButtonPermissionsXK = JSON.parse(
      localStorage.getItem("ButtonPermissionsXK")
    );
    if (
      global.ButtonPermissionsXK &&
      global.ButtonPermissionsXK.indexOf(value) < 0
    ) {
      el.style.display = "none";
    }
  },
};
